import { urlB64ToUint8Array } from './utils';
import { getServiceWorkerRegistration } from './ServiceWorkers';

// TODO: might need to read this as required to ensure it has been defined.
function applicationServerPublicKey(){
  return window.kms.application_public_key;
}

function updatePushSubscriptionOnServer(subscription) {
  // Send subscription to application server
  return fetch("/kms/members/push-subscription", {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF': window.kms.csrf_token
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(subscription) // body data type must match "Content-Type" header
  }).then(() => {
      return subscription;
  })
}
var _isSubscribed = null;
function subscribeUser() {
  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey());
  return getServiceWorkerRegistration().then((registration) => {
      return registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
      .then((subscription) => {return updatePushSubscriptionOnServer(subscription)})
      .then(() => {
            console.log('User is subscribed.');
            _isSubscribed = true;
            return true;
      })
      .catch(function(err) {
        console.log('Failed to subscribe the user: ', err);
        return false;
      });
  });
}

function unsubscribeUser() {
  return getSubscription()
  .then(function(subscription) {
    if (subscription) {
      return subscription.unsubscribe();
    }
  })
  .catch(function(error) {
    console.log('Error unsubscribing', error);
    return false;
  })
  .then(function() {
    updatePushSubscriptionOnServer(null);

    console.log('User is unsubscribed.');
    _isSubscribed = false;
    return true;

  });
}

function getSubscription() {
    return getServiceWorkerRegistration().then((registration)=> registration.pushManager.getSubscription());
}
function isSubscribed() {
    if (_isSubscribed !== null)
        return _isSubscribed;
    if ('PushManager' in window) {
         return getSubscription()
          .then(function(subscription) {
            updatePushSubscriptionOnServer(subscription).then(()=>{});
            return _isSubscribed = !(subscription === null);
          });
    } else {
        return new Promise((resolve, reject) => {reject('Push Messaging not supported')})
    }

}
export {subscribeUser, unsubscribeUser, isSubscribed}
